<script setup>
import { storeToRefs } from "pinia";
import useCotizacionEstandarUsesStore from "@/store/cotizaciones/estandar/uses";

const { uses } = storeToRefs(useCotizacionEstandarUsesStore());
</script>

<template>
  <section>
    <div class="table responsive">
      <table class="table table-sm text-xs table-bordered">
        <tbody>
          <tr>
            <th colspan="2"><u>Equipment</u></th>
          </tr>
          <tr>
            <td>Payment to OEM (or Lessee if SLB)</td>
            <td>${{ uses.conceptos.paymentToOEM }}</td>
          </tr>
          <tr>
            <td>VAT on Equipment</td>
            <td>${{ uses.conceptos.vatOnEquipment }}</td>
          </tr>
          <tr>
            <th>Total Equipment Uses</th>
            <th>${{ uses.totales.equipment }}</th>
          </tr>
          <tr>
            <td colspan="2" class="py-3 bg-white"></td>
          </tr>
          <tr>
            <th colspan="2">Servicer Fees & Partial Day Interest</th>
          </tr>
          <tr>
            <td>Servicer Fee - Opening</td>
            <td>${{ uses.conceptos.servicerFeeOpening }}</td>
          </tr>
          <tr>
            <td>Servicer Fee - VAT on Opening Fee</td>
            <td>${{ uses.conceptos.servicerFeeOpeningVat }}</td>
          </tr>
          <tr>
            <td>1st Month's Rent</td>
            <td>${{ uses.conceptos.firstMonthsRent }}</td>
          </tr>
          <tr>
            <td>VAT on Opening Fee</td>
            <td>${{ uses.conceptos.vatOnOpeningFee }}</td>
          </tr>
          <tr>
            <td>Partial Day Interest</td>
            <td>${{ uses.conceptos.partialDayInterest }}</td>
          </tr>
          <tr>
            <td>Partial Day Interest VAT</td>
            <td>${{ uses.conceptos.partialDayInterestVat }}</td>
          </tr>
          <tr>
            <th>Total Fees Paid to Servicer</th>
            <th>${{ uses.totales.totalFeesPaidToServicer }}</th>
          </tr>
          <tr>
            <td colspan="2" class="py-3 bg-white"></td>
          </tr>
          <tr style="font-size: 15px; color: #000">
            <th>Total Uses</th>
            <th>${{ uses.totales.totalUses }}</th>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<style scoped>
td,
th,
thead {
  text-align: left;
}
</style>
